module.exports = __webpack_public_path__ + "img/vi.150b0069.png";